import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import { apiPostAuth } from "../../utils/api";

export default function LoanListFinishedPage() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [loanList, setLoanList] = useState([]);

  useEffect(() => {
    fetchLoanList();
  }, []);

  const fetchLoanList = async () => {
    try {
      const response = await apiPostAuth(
        "loan/get_loan_list_finished.php"
      );

      if (response.result === 1) {
        setLoanList(response.loan_list || []);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenLoanDetail = (loanId) => {
    navigate(`/dashboard/loan/${loanId}`);
  };

  const formatCurrency = (value) => {
    return Number(value || 0).toLocaleString(
      "id-ID",
      {
        style: "currency",
        currency: "IDR",
        maximumFractionDigits: 0,
      }
    );
  };

  const formatDate = (dateString) => {
    if (!dateString || dateString.length < 14)
      return "-";

    const year = dateString.slice(0, 4);
    const month = dateString.slice(4, 6);
    const day = dateString.slice(6, 8);
    const hour = dateString.slice(8, 10);
    const minute = dateString.slice(10, 12);
    const second = dateString.slice(12, 14);

    const date = new Date(
      `${year}-${month}-${day}T${hour}:${minute}:${second}`
    );

    return date.toLocaleString("id-ID", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  if (loading) {
    return (
      <div
        style={{
          textAlign: "center",
          marginTop: "50px",
        }}
      >
        <div className="loading-spinner"></div>
        <p>Memuat Pinjaman...</p>
      </div>
    );
  }

  return (
    <div style={{ padding: "20px" }}>
      <section style={sectionStyle}>
        <div style={headerContainerStyle}>
          <div>
            <h1 style={pageTitleStyle}>
              Daftar Pinjaman Selesai
            </h1>

            <p style={pageSubtitleStyle}>
              Ini adalah daftar Pinjaman yang sudah selesai dan sudah dilunasi.
            </p>
          </div>

          <div style={countBadgeStyle}>
            {loanList.length} Pinjaman
          </div>
        </div>

        {loanList.length === 0 ? (
          <div style={emptyBoxStyle}>
            <p
              style={{
                margin: 0,
                color: "#6b7280",
              }}
            >
              Belum ada pinjaman yang diselesaikan
            </p>
          </div>
        ) : (
          <div
            style={{
              display: "grid",
              gap: "14px",
            }}
          >
            {loanList.map((loan) => (
              <div
                key={loan.loan_id}
                style={loanCardStyle}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                    flex: 1,
                  }}
                >
                  <img
                    src={
                      loan.member_profile_picture
                    }
                    alt={
                      loan.member_full_name
                    }
                    style={
                      memberImageStyle
                    }
                  />

                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        flexWrap: "wrap",
                      }}
                    >
                      <h3
                        style={{
                          color: "#1f2937",
                          fontSize: "1.1rem",
                        }}
                      >
                        {
                          loan.member_full_name
                        }
                      </h3>

                      <div
                        style={{
                          ...statusBadgeStyle,
                          backgroundColor:
                            loan.is_active === 1
                              ? "#166534"
                              : "#fee2e2",
                          color:
                            loan.is_active === 1
                              ? "#ffffff"
                              : "#696969",
                        }}
                      >
                        {loan.is_active === 1
                          ? "Aktif"
                          : "Selesai"}
                      </div>
                    </div>

                    <p style={loanAmountStyle}>
                      {formatCurrency(
                        loan.loan_amount
                      )}
                    </p>

                    <div
                      style={{
                        display: "flex",
                        gap: "14px",
                        flexWrap: "wrap",
                        marginTop: "8px",
                      }}
                    >
                      <p style={metaTextStyle}>
                        Bunga:{" "}
                        <strong>
                          {
                            loan.interest_rate
                          }
                          %
                        </strong>
                      </p>

                      <p style={metaTextStyle}>
                        Durasi:{" "}
                        <strong>
                          {
                            loan.payment_term
                          }{" "}
                          bulan
                        </strong>
                      </p>

                      <p style={metaTextStyle}>
                        Tanggal Pinjaman:{" "}
                        <strong>
                          {formatDate(
                            loan.loan_time_stamp
                          )}
                        </strong>
                      </p>
                    </div>

                    <p style={metaTextStyle}>
                        ID Pinjaman:{" "}
                        <strong>
                          {
                            loan.loan_id
                          }
                          
                        </strong>
                      </p>
                  </div>
                </div>

                <button
                  onClick={() =>
                    handleOpenLoanDetail(
                      loan.loan_id
                    )
                  }
                  className="primary-button"
                  style={{
                    minWidth: "120px",
                    padding:
                      "10px 16px",
                  }}
                >
                  Detail Pinjaman
                </button>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}

/* Styles */

const sectionStyle = {
  backgroundColor: "#fff",
  padding: "22px",
  borderRadius: "12px",
  boxShadow:
    "0 2px 6px rgba(0,0,0,0.05)",
};

const headerContainerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "22px",
  gap: "15px",
  flexWrap: "wrap",
};

const pageTitleStyle = {
  margin: 0,
  fontSize: "1.8rem",
  color: "#1f2937",
};

const pageSubtitleStyle = {
  margin: "6px 0 0 0",
  color: "#6b7280",
};

const countBadgeStyle = {
  backgroundColor: "#eff6ff",
  color: "#2563eb",
  padding: "10px 14px",
  borderRadius: "999px",
  fontWeight: "700",
  fontSize: "0.9rem",
};

const loanCardStyle = {
  backgroundColor: "#fff",
  border: "1px solid #e5e7eb",
  borderRadius: "12px",
  padding: "18px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "16px",
  boxShadow:
    "0 2px 4px rgba(0,0,0,0.04)",
  flexWrap: "wrap",
};

const memberImageStyle = {
  width: "62px",
  height: "62px",
  borderRadius: "50%",
  objectFit: "cover",
  border: "2px solid #e5e7eb",
  flexShrink: 0,
};

const loanAmountStyle = {
  margin: "8px 0 0 0",
  fontSize: "1.15rem",
  fontWeight: "700",
  color: "#111827",
};

const metaTextStyle = {
  margin: 0,
  fontSize: "0.9rem",
  color: "#6b7280",
};

const statusBadgeStyle = {
  padding: "6px 10px",
  borderRadius: "999px",
  fontSize: "0.8rem",
  fontWeight: "700",
};

const emptyBoxStyle = {
  padding: "25px",
  borderRadius: "12px",
  backgroundColor: "#f9fafb",
  border: "1px dashed #d1d5db",
  textAlign: "center",
};